import log from './modules/log.js';
export default {
  log: async (type, id, meta, isMobile, isProduction) => await log(type, id, meta, isMobile, false, isProduction)
};